import { useRef, useState } from "react";
import Input from "../Input";

const Form3 = ({
  nextHandler,
  changeHandler,
  formState = {},
  loading = false,
}) => {
  const heightFoot = useRef(null);
  const heightInches = useRef(null);
  const [foot, setFoot] = useState(0);
  const [inches, setInches] = useState(0);
  const [weight, setWeight] = useState(
    formState.weight ? formState.weight : ""
  );
  const [heightMetric, setHeightMetric] = useState("ft");

  const setHeight = (value) => {
    changeHandler({ height: value });
  };

  const weightChangeHandler = (e) => {
    setWeight(e.target.value);
    changeHandler({ weight: parseFloat(e.target.value) });
  };

  const heightHandler = (e) => {
    switch (e.target.name) {
      case "foot":
        return setFoot(e.target.value);
      case "inches":
        return setInches(e.target.value);
    }
    if (heightMetric === "ft") {
      setHeight(
        inches * 2.54 + foot * 30.48
      );
    } else if (heightMetric === "cm") {
      setHeight(foot);
    } else {
      setHeight(foot * 100);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (foot != "" && weight != "") {
      nextHandler();
    }
  };

  return (
    <div className={"programsContainer programsContainer3"}>
      <form onSubmit={submitHandler}>
        <div className="row m-0 mt-5">
          <div className="col-3 col-sm-3 m-auto">
            <div className="blogCategoryTitle fw-600">Height</div>
          </div>
          <div className="col-9 col-sm-9 p-0">
            <div className="row m-0">
              <div className="col-6 col-sm-6 ps-0">
                <input
                  className="calculatorInput w-100"
                  value={foot}
                  name="foot"
                  type="number"
                  onChange={heightHandler}
                  max={7}
                  required
                />
              </div>
              <div className="col-6 col-sm-6">
                <div className="row m-0 d-flex">
                  <select
                    className="calculatorInput w-100"
                    onChange={(e) => setHeightMetric(e.target.value)}
                  >
                    <option value="ft">Feet</option>
                    <option value="cm">cm</option>
                    <option value="m">m</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row m-0 mt-4">
          <div className="col-3 col-sm-3 m-auto">
            <div className="blogCategoryTitle fw-600"></div>
          </div>
          <div className="col-9 col-sm-9 p-0">
            {heightMetric === "ft" && (
              <div className="row m-0">
                <div className="col-6 col-sm-6 ps-0">
                  <Input
                    className="calculatorInput w-100"
                    value={inches}
                    name="inches"
                    onChange={heightHandler}
                    max={150}
                  />
                </div>

                <div className="col-6 col-sm-6">
                  <div className="row m-0 d-flex">
                    <div className="calculatorInput w-100 purp calculatorInput_3">
                      Inches
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="row m-0 mt-4">
          <div className="col-3 col-sm-3 m-auto">
            <div className="blogCategoryTitle fw-600">Weight</div>
          </div>
          <div className="col-9 col-sm-9 p-0">
            <div className="row m-0">
              <div className="col-6 col-sm-6 ps-0">
                <Input
                  className="calculatorInput w-100"
                  value={weight}
                  onChange={weightChangeHandler}
                  required
                />
              </div>
              <div className="col-6 col-sm-6">
                <select className="calculatorInput2 purp">
                  <option value="kg">Kg</option>
                  <option value="lbs">Lbs</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-3">
          <button type="submit" className="btn sendButton mb-0">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default Form3;
